import React from "react";
import "./Loader.css";

const Loader = ({ inline = false, label = "Готовим что-то вкусное..." }) => {
  if (inline) {
    return (
      <div className="Loader Loader--inline">
        <span className="Loader--Spinner" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="Loader">
      <div className="Loader--Inner">
        <span className="Loader--Spinner" aria-hidden="true" />
        <p className="Loader--Text">{label}</p>
      </div>
    </div>
  );
};

export default Loader;
